import { Link } from 'react-router-dom';
import { Activity, ArrowRight } from 'lucide-react';
import { useSystemHealth } from '../hooks/useSystemHealth';

export const healthTitles = { healthy: 'All monitored checks passing', attention: 'Checks need attention', waiting: 'Startup or maintenance in progress', unknown: 'Current health unknown' };
export const healthColors = { healthy: 'text-emerald-400', attention: 'text-red-400', waiting: 'text-amber-400', unknown: 'text-amber-400' };

export default function SystemHealthSummary() {
  const { data, loading, overall } = useSystemHealth();
  return <Link to="/system-health" className="glass rounded-xl border border-white/10 p-5 flex items-center gap-4 hover:border-primary/40" data-testid="system-health-summary">
    <Activity className={`w-6 h-6 shrink-0 ${healthColors[overall]}`} />
    <div className="flex-1"><div className="text-xs text-muted-foreground uppercase tracking-wider">SAV-1 · Background monitoring</div>
      <div className={`font-semibold mt-1 ${healthColors[overall]}`}>{loading ? 'Connecting to monitor…' : healthTitles[overall]}</div>
      <p className="text-xs text-muted-foreground mt-1">{data?.available ? `${Object.keys(data.targets).length} checks · ${data.incidents.length} open incidents · continues when Mayr Ops is closed` : 'Connecting to the independent server monitor'}</p>
    </div><ArrowRight className="w-5 h-5 text-primary" />
  </Link>;
}
